import * as React from 'react';
import {RouteComponentProps, withRouter} from "react-router";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Toast from "../../helper/Toast";
import CommonStreamItem, {StreamItemAction} from "../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import LeadQuoteDeletedEvent from "../../../model/lead/event/LeadQuoteDeletedEvent";
import ConfirmQuoteRestoreModal from "../modal/ConfirmQuoteRestoreModal";
import {restoreQuote} from "../../../store/action/lead/lead";
import {LeadEventTypeEnum} from "../../../model/lead/event/LeadEvent";
import {RootState} from "../../../store/reducer/root/RootState";
import LeadQuoteRestoredEvent from "../../../model/lead/event/LeadQuoteRestoredEvent";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface ComponentProps {
	/**
	 * Lead activity to display.
	 */
	activity: LeadQuoteDeletedEvent | LeadQuoteRestoredEvent;
	/**
	 * Indicates if action are disabled
	 */
	readOnly?: boolean
}

interface ReduxProps {
	/**
	 * Indicates if restore action is available.
	 */
	isQuoteRestoreActionAvailable: boolean;
}

interface DispatchProps {
	/**
	 * Restore deleted quote action.
	 * @param {string} leadId
	 * @param {string} quoteId
	 */
	restoreQuote: (leadId: string, quoteId: string) => void;
}

interface State {
	/**
	 * Indicates if quote restore confirmation modal is visible.
	 */
	confirmationVisible: boolean;
}

type Props = ComponentProps & RouteComponentProps<{}> & ReduxProps & DispatchProps;

class LeadActivityQuoteDelete extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {confirmationVisible: false};
		this.onModalConfirm = this.onModalConfirm.bind(this);
	}

	render() {
		let actions: StreamItemAction[] = [];
		if (this.props.isQuoteRestoreActionAvailable && !this.props.readOnly) {
			actions.push(StreamItemAction.new("Restore deleted quote", () => this.setState({confirmationVisible: true})));
		}
		return (
			<React.Fragment>
				<CommonStreamItem event={this.props.activity} actions={actions}/>
				{this.state.confirmationVisible &&
				<ConfirmQuoteRestoreModal onClose={() => this.setState({confirmationVisible: false})}
										  onConfirm={this.onModalConfirm}/>}
			</React.Fragment>
		);
	}

	onModalConfirm() {
		this.setState({confirmationVisible: false}, () =>
			this.props.restoreQuote(this.props.activity.leadId, this.props.activity.data.quoteId));
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	let isQuoteRestoreActionAvailable = false;
	if (props.activity.type === LeadEventTypeEnum.QuoteDeleted) {
		const isQuoteRestored = state.lead.events.getOrElse([]).some(e => {
			const quoteRestoreEvent = e as LeadQuoteRestoredEvent;
			return e.type === LeadEventTypeEnum.QuoteRestored
				&& quoteRestoreEvent.data.quoteId === props.activity.data.quoteId
				&& quoteRestoreEvent.creationDate.isAfter(props.activity.creationDate)
		});
		isQuoteRestoreActionAvailable = !isQuoteRestored;
	}
	return {isQuoteRestoreActionAvailable};
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		restoreQuote: (leadId: string, quoteId: string) =>
			dispatch(restoreQuote(leadId, quoteId,
				() => Toast.success("Deleted quote has been restored", "Restore quote"),
				(error: any) => {
					let err: string;
					if (error && error.response && error.response.status === 412)
						err = "Cannot restore quote. Lead site is required.";
					else
						err = "Sorry, something went wrong. Try again later.";
					notifyBugsnagAndShowToast(error, "Restore deleted quote", err);
				}))
	};
}

export default withRouter<ComponentProps>(connect(mapStateToProps, mapDispatchToProps)(LeadActivityQuoteDelete))
